const types = {
  SET_LISTA_MOTIVOS_RESTRICOES_ARQUIVO: 'SET_LISTA_MOTIVOS_RESTRICOES_ARQUIVO',
  SET_LISTA_ARQUIVOS: 'SET_LISTA_ARQUIVOS',
  SET_LISTA_PECAS: 'SET_LISTA_PECAS',
  SET_ARQUIVO: 'SET_ARQUIVO',
  SET_ARQUIVO_BLOB_URL: 'SET_ARQUIVO_BLOB_URL',
  SET_PASSO_ATUAL: 'SET_PASSO_ATUAL',
  SET_SITUACAO_VINCULO: 'SET_SITUACAO_VINCULO',
  SET_LISTA_DOCUMENTOS: 'SET_LISTA_DOCUMENTOS',
  SET_DOCUMENTO_SELECIONADO: 'SET_DOCUMENTO_SELECIONADO',
  SET_JUSTIFICATIVA_CANCELAMENTO: 'SET_JUSTIFICATIVA_CANCELAMENTO',
  SET_LISTA_ARQUIVOS_ASSINADOS_NAO_VINCULADOS: 'SET_LISTA_ARQUIVOS_ASSINADOS_NAO_VINCULADOS',
  REMOVER_ARQUIVO_LISTA: 'REMOVER_ARQUIVO_LISTA',
  ALTERAR_PECA_LISTA: 'ALTERAR_PECA_LISTA',
  ALTERAR_SEQUENCIAL: 'ALTERAR_SEQUENCIAL',

  SHOW_EDICAO_ARQUIVO_DIALOG: 'SHOW_EDICAO_ARQUIVO_DIALOG',
  HIDE_EDICAO_ARQUIVO_DIALOG: 'HIDE_EDICAO_ARQUIVO_DIALOG',
  SHOW_CANCELAMENTO_PECA_DIALOG: 'SHOW_CANCELAMENTO_PECA_DIALOG',
  HIDE_EXCLUSAO_ARQUIVO_DIALOG: 'HIDE_EXCLUSAO_ARQUIVO_DIALOG',
  SHOW_ADICIONAR_ARQUIVO_ASSINADO_DIALOG: 'SHOW_ADICIONAR_ARQUIVO_ASSINADO_DIALOG',
  HIDE_ADICIONAR_ARQUIVO_ASSINADO_DIALOG: 'HIDE_ADICIONAR_ARQUIVO_ASSINADO_DIALOG',
  SHOW_INFORMACOES_PECAS_UPLOAD_DIALOG: 'SHOW_INFORMACOES_PECAS_UPLOAD_DIALOG',
  HIDE_INFORMACOES_PECAS_UPLOAD_DIALOG: 'HIDE_INFORMACOES_PECAS_UPLOAD_DIALOG',

  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR',
  SHOW_CONFIRMATION_DIALOG: 'ui/SHOW_CONFIRMATION_DIALOG',
  HIDE_CONFIRMATION_DIALOG: 'ui/HIDE_CONFIRMATION_DIALOG'
}

export default types
